class SkincareElement extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.querySelectorAll('.skincare__option-wrapper').forEach((option) => {
      option.addEventListener('click', () => {
        const optionId = option.getAttribute('data-option-id');
        this.querySelector('.skincare__options').style.display = 'none';
        this.querySelector(`[data-detail-id="${optionId}"]`).style.display = 'flex';
      });
    });
  }
}

customElements.define('skincare-element', SkincareElement);

function toggleSections() {
  document.querySelectorAll('.skincare__detail').forEach((detail) => {
    detail.style.display = 'none';
  });
  document.querySelector('.skincare__options').style.display = 'flex';
}